import { seoMeta } from "@/lib/ui/seo";

export function breedPageHead(breedId: string) {
    return seoMeta({
        title: "Breed — Wags",
        description: "Find available dogs of this breed on Wags.",
        url: `/breed/${breedId}`,
        noindex: true,
    });
}
